import { Mutation, MutationTree } from 'vuex'
import { State } from './state'
import {ProductAggregatedStatPobraniaSum} from "@/store/modules/statsPobrania/types";
import _ from 'lodash'
import {ObjectDataWithPaginator} from "@/store/modules/dashboard/types";


export function updatingAggregatedStatsPobraniaSum(state: State,  forceUpdate: boolean = false) {
    state.aggregatedStatsPobraniaSumUpdating = true;
    state.aggregatedStatsPobraniaSumBuffer = (forceUpdate) ? [] : state.aggregatedStatsPobraniaSum;
}

export function updatedAggregatedStatsPobraniaSum(state: State) {
    state.aggregatedStatsPobraniaSumUpdating = false;
    state.aggregatedStatsPobraniaSum = _.sortBy(state.aggregatedStatsPobraniaSumBuffer, o => o.productId);
    state.aggregatedStatsPobraniaSumBuffer = [];
}

export function loadedAggregatedStatsPobraniaSumForProduct(state: State, productStat: ProductAggregatedStatPobraniaSum) {
    state.aggregatedStatsPobraniaSumBuffer.push(productStat);
}

export function loadingAggregatedStatsPobraniaBetweenDatesForProduct(state: State) {
    state.aggregatedStatsPobraniaLoading = true;
}

export function loadedAggregatedStatsPobraniaForProduct(state: State, data: ObjectDataWithPaginator) {
    state.aggregatedStatsPobraniaLoading = false;
    state.aggregatedStatsPobrania = data.data as Array<object>;
    state.aggregatedStatsPobraniaCurrentPage = data.currentPage;
    state.aggregatedStatsPobraniaTotal = data.total;
}

export function loadingDetailedStatsPobraniaBetweenDatesForProduct(state: State) {
    state.detailedStatsPobraniaLoading = true;
}

export function loadedDetailedStatsPobraniaForProduct(state: State, data: Array<object>) {
    state.detailedStatsPobraniaLoading = false;
    state.detailedStatsPobrania = data as Array<object>;
}

export default <MutationTree<State>> {
    updatingAggregatedStatsPobraniaSum,
    updatedAggregatedStatsPobraniaSum,
    loadedAggregatedStatsPobraniaSumForProduct,
    loadingAggregatedStatsPobraniaBetweenDatesForProduct,
    loadedAggregatedStatsPobraniaForProduct,
    loadingDetailedStatsPobraniaBetweenDatesForProduct,
    loadedDetailedStatsPobraniaForProduct
}
